module.exports = __webpack_public_path__ + "static/after3-ca98789a76c5f5302e3675d7ca0796cd.png";